module.exports = __webpack_public_path__ + "img/clope@2x.a2ea049a.png";